"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
require("../../scss/_icon-label.scss");
/**
 * @component IconLabel
 * @example
 * return (
 *   <IconLabel
 *     icon={<LocationOnIcon />}
 *     label={facility?.facilityName}
 *   />
 * )
 *
 * @param {Component} icon pass a MUI icon component here
 * @param {string} label label for the icon
 * @param {boolean} isBold is the label text bold?
 * @param {boolean} showIconBackground whether to show a circle around the icon or not
 */
var IconLabel = function (props) {
    var icon = props.icon, label = props.label, _a = props.isBold, isBold = _a === void 0 ? false : _a, _b = props.showIconBackground, showIconBackground = _b === void 0 ? true : _b;
    return (react_1.default.createElement("div", { className: showIconBackground ? 'icon-label' : 'no-background-styles' },
        react_1.default.createElement(material_1.Grid, { container: true, alignItems: "center" },
            react_1.default.createElement(material_1.Grid, { item: true },
                react_1.default.createElement("span", { className: "icon" }, icon)),
            react_1.default.createElement(material_1.Grid, { item: true },
                react_1.default.createElement("span", { className: "label ".concat(isBold ? 'sub-section-title' : 'normal-weight') }, label ? label : "N/A")))));
};
exports.default = IconLabel;
